// style
import React from 'react';
import './style/header.css';
// icon
import { IconCaretDown, IconMenu } from "@tabler/icons-react";

const AdminHeader = () => {
    // hide collapse
    return (
        <>
            <section id="header">
                {/* admin head */}
                <div className="admin-head pb-0 overflow-hidden">
                    {/* admin content */}
                    <div className="admin-content-head">
                        {/* card */}
                        <div className="card header-card-bg card-body border-0 px-xl-4">
                            <div className="row">
                                {/* menu card for mobile */}
                                <div className="col-2 d-xl-none d-inline-block position-relative">
                                    <div className="admin-place admin-bar-toggle" data-bs-toggle="offcanvas"
                                        data-bs-target="#admin-canvas">
                                        <div className="d-flex justify-content-center align-items-center">
                                            <IconMenu />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-10 order-xl-1 position-relative">
                                    {/* admin place */}
                                    <div className="admin-place position-absolute" style={{ width: "90%", zIndex: "999" }}>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <div className='d-flex align-items-center'>
                                                <div className="admin-profile"></div>
                                                <span className="admin-profile-text ms-2"
                                                    id="user-name-panel">
                                                    {localStorage.getItem('username') ? localStorage.getItem('username') : 'مادوند : پنل کاربری'}
                                                </span>
                                            </div>
                                            <IconCaretDown
                                                className="fas fa-angle-down vertical-td mt-1 ms-2 font-12 admin-profile-icon"
                                                size={14}
                                            />
                                        </div>
                                    </div>
                                    {/* end admin place */}
                                </div>
                                <div className="col-xl-10 order-xl-2 order-3 mt-xl-0 mt-3">
                                    {/* search input */}
                                    <input type="search" id="admin-search"
                                        placeholder="جستجو کنید"
                                        className="form-control vertical-td" />
                                </div>
                            </div>
                        </div>
                        {/* end card */}
                    </div>
                    {/* end admin content   */}
                </div>
                {/* end admin head */}
            </section>
        </>
    )
}

export default AdminHeader;